<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ query.categoryName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1 && query.category != 2" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">{{ query.category == 0 ? "新增项目" : "新增计划" }}</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1 && query.category != 2" class="btn" size="small" type="danger" :disabled="multiple" v-preventReClick @click="handleDelete">批量删除</el-button>

          <el-button v-if="tableAcl.indexOf('Print') != -1 && query.category == 2" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handlePrint">数据打印</el-button>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>
      <el-tabs v-model="query.category" @tab-click="handleClick" stretch>
        <el-tab-pane v-for="item in PatrolQualityControlOptions" :key="item.id" :name="item.id">
          <template slot="label">
            <span style="margin: 0 10px"> {{ item.name }} </span>
          </template>
        </el-tab-pane>
      </el-tabs>
      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <template v-for="(item, index) in tableColumn">
          <el-table-column :key="index" :align="item.align" :label="item.label" :prop="item.prop" :fixed="item.fixed" :formatter="item.formatter" :show-overflow-tooltip="item.tooltip" :width="item.width" :min-width="item.minWidth" v-if="item.type == 'ware'">
            <template slot-scope="scope">
              <template v-if="item.formatter">
                <div>
                  {{
                    item.formatter(null, null, scope.row[item.rowData.data1])
                  }}
                </div>
                <div>
                  {{
                    item.formatter(null, null, scope.row[item.rowData.data2])
                  }}
                </div>
              </template>
              <template v-else>
                <div>
                  {{ scope.row[item.rowData.data1] }}
                </div>
                <div>
                  {{ scope.row[item.rowData.data2] }}
                </div>
              </template>
            </template>
          </el-table-column>
          <!-- 日期 -->
          <el-table-column :key="index" :align="item.align" :label="item.label" :prop="item.prop" :fixed="item.fixed" :formatter="item.formatter" :show-overflow-tooltip="item.tooltip" :width="item.width" v-else-if="item.type == 'Date'">
            <template slot-scope="scope">
              <div>
                {{ parseTime(new Date(scope.row[item.prop]), "{y}-{m}-{d}") }}
              </div>
            </template>
          </el-table-column>
          <!-- 时间 -->
          <el-table-column :key="index" :align="item.align" :label="item.label" :prop="item.prop" :fixed="item.fixed" :formatter="item.formatter" :show-overflow-tooltip="item.tooltip" :width="item.width" v-else-if="item.type == 'DateTime'">
            <template slot-scope="scope">
              <div>
                {{ parseTime(new Date(scope.row[item.prop]), "{y}-{m}-{d}") }}
              </div>
              <div>
                {{ parseTime(new Date(scope.row[item.prop]), "{h}:{i}:{s}") }}
              </div>
            </template>
          </el-table-column>
          <!-- 普通列 -->
          <el-table-column v-else :key="index" :align="item.align" :label="item.label" :prop="item.prop" :fixed="item.fixed" :formatter="item.formatter" :show-overflow-tooltip="item.tooltip" :width="item.width"></el-table-column>
        </template>
        <el-table-column v-if="isWorkflowTable" label="审批人" width="100" align="center" prop="approverNames" />
        <el-table-column prop="statusName" label="流程状态" width="80" v-if="isWorkflowTable">
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>
        <el-table-column prop="temState" label="模板状态" width="100" align="center" v-if="query.category == 0">
          <template slot-scope="scope">
            <div v-if="scope.row.state == 0" style="color:#6EA204">
              {{ scope.row.stateName }}
            </div>
            <div v-else-if="scope.row.state == 1" style="color:#CE1126">
              {{ scope.row.stateName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="planState" label="计划状态" width="100" align="center" v-if="query.category != 0">
          <template slot-scope="scope">
            <div v-if="scope.row.state == 0" style="color:#CCCCCC">
              <!-- 已忽略 -->
              {{ scope.row.stateName }}
            </div>
            <div v-else-if="scope.row.state == 1" style="color:#E8873D">
              <!-- 待执行 -->
              {{ scope.row.stateName }}
            </div>
            <div v-else-if="scope.row.state == 2" style="color:#6EA204">
              <!-- 执行中 -->
              {{ scope.row.stateName }}
            </div>
            <div v-else-if="scope.row.state == 3" style="color:#CE1126">
              <!-- 已过期 -->
              {{ scope.row.stateName }}
            </div>
            <div v-else-if="scope.row.state == 4" style="color:#6EA204">
              <!-- 已完成 -->
              {{ scope.row.stateName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" :width="operationWidth">
          <template slot-scope="scope">
            <el-button v-if="
                scope.row.status == 1 &&
                  isShowApproveButton(scope.row.approverIds)
              " type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
            <!-- 项目 -->
            <template v-if="query.category == 0">
              <el-button v-if="CanEditTem(scope.row) && tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="color-blue" :class="{
                  'margin-left20':
                    scope.row.status == 1 &&
                    isShowApproveButton(scope.row.approverIds),
                }">编辑</el-button>
              <span v-else class="color-blue" :class="{
                  'margin-left20':
                    scope.row.status == 1 &&
                    isShowApproveButton(scope.row.approverIds),
                }">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
              <el-button v-if="tableAcl.indexOf('Remove') != -1 && CanEditTem(scope.row)" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
              <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
            </template>
            <!-- 计划 -->
            <template v-else-if="query.category == 1">
              <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue" :class="{
                  'margin-left20':
                    scope.row.status == 1 &&
                    isShowApproveButton(scope.row.approverIds),
                }">查看详情</el-button>
              <el-button v-if="CanEdit(scope.row) && tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
              <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
              <el-button v-if="CanDelete(scope.row) && tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
              <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
            </template>
            <!-- 执行 -->
            <template v-else>
              <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue" :class="{
                  'margin-left20':
                    scope.row.status == 1 &&
                    isShowApproveButton(scope.row.approverIds),
                }">查看详情</el-button>
              <el-button v-if="CanResponse(scope.row) && tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="planResponse(scope.row)" class="margin-left20 color-blue">响应</el-button>
              <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>

    <el-dialog title="巡检质控项目" :visible.sync="dialogVisible" :center="true" width="500px" :before-close="cancel" :close-on-click-modal="false">
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="项目名称" prop="name">
              <el-input v-model="form.name" placeholder="请填写项目名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="项目说明" prop="desc">
              <el-input v-model="form.desc" placeholder="请填写项目说明" type="textarea" resize="none" :rows="5"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="">
        <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
        <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  RemovePatrolProjects,
  GetPatrolProjects,
  GetPatrolProjectById,
  SavePatrolProject,
  RemovePatrolPlans,
  GetPatrolPlans,
  GetPatrolPlanExecutes,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
// import Info from './info';
import { PatrolQualityControlOptions } from "@/enum";

export default {
  mixins: [GetDataMixin],
  components: {
    // Info
  },
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        category: "0",
        categoryName: "巡检质控项目",
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      // 打开详情
      showInfo: false,
      id: 0,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      PatrolQualityControlOptions: PatrolQualityControlOptions,
      tableColumn: [],
      tableColumn1: [
        {
          label: "项目名称",
          prop: "name",
        },
        {
          label: "项目说明",
          prop: "desc",
          tooltip: true,
        },
      ],
      tableColumn2: [
        {
          type: "ware",
          label: "巡检质控计划名称",
          rowData: {
            data1: "name",
            data2: "no",
          },
          minWidth: "180",
        },
        {
          label: "巡检质控室",
          prop: "deptName",
          width: "140",
        },
        {
          label: "巡检质控人员",
          prop: "userName",
          width: "140",
        },
        {
          type: "ware",
          label: "巡检质控有效期",
          rowData: {
            data1: "date",
            data2: "endDate",
          },
          width: "140",
          formatter: this.DateFomatter,
        },
        {
          label: "预计费用",
          prop: "estimateToTalAmount",
          minWidth: "100",
          formatter: this.toDecimal4,
        },
        {
          label: "实际费用",
          prop: "totalAmount",
          minWidth: "100",
          formatter: this.toDecimal4,
        },
        {
          label: "下次巡检人员",
          prop: "nextUserMame",
          width: "140",
        },
        {
          type: "Date",
          label: "预计下次日期",
          prop: "nextDate",
          width: "140",
        },
        {
          label: "创建人",
          prop: "createdUserName",
          minWidth: "120",
        },
        {
          type: "DateTime",
          label: "创建时间",
          prop: "createdTime",
          width: "140",
        },
        // {
        //   label: "备注",
        //   prop: "remark",
        //   width: "200",
        //   tooltip: true,
        // },
      ],
      tableColumn3: [
        {
          type: "ware",
          label: "巡检质控计划名称",
          rowData: {
            data1: "patrolPlanName",
            data2: "no",
          },
          minWidth: "180",
        },
        {
          type: "Date",
          label: "开始日期",
          prop: "date",
          width: "140",
        },
        {
          type: "Date",
          label: "截至日期",
          prop: "endDate",
          width: "140",
        },
        {
          label: "巡检质控科室",
          prop: "deptName",
          width: "140",
        },
        {
          label: "巡检质控人员",
          prop: "userName",
          width: "140",
        },
        {
          label: "备注",
          prop: "remark",
          minWidth: "200",
          tooltip: true,
        },
      ],
      operationWidth: 150,
      // 弹框
      form: {},
      rules: {
        name: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
      },
      dialogVisible: false,
    };
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    refenceQuery () {
      this.query = {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
        category: "0",
        categoryName: "巡检质控项目",
      };
      this.tableColumn = this.tableColumn1;
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
    },
    // 获取列表
    getData () {
      if (this.query.category == "0") {
        GetPatrolProjects(this.query).then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;
        });
      } else if (this.query.category == "1") {
        GetPatrolPlans(this.query).then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;
        });
      } else {
        GetPatrolPlanExecutes(this.query).then((res) => {
          this.tableData = res.returnData.data;
          this.total = res.returnData.totalCount;
        });
      }
    },
    // 查看信息
    handleInfo (row) {
      switch (this.query.category) {
        case "1":
          this.$router.push(
            "/patrol-plan-edit?formMode=0&id=" +
            row.id +
            "&category=" +
            this.query.category
          );
          break;
        case "2":
          this.$router.push(
            "/patrol-plan-edit?formMode=0&id=" +
            row.patrolPlanId +
            "&category=" +
            this.query.category
          );
          break;
      }
    },
    // 新建
    handleAdd () {
      if (this.query.category == "0") {
        this.dialogVisible = true;
      } else {
        this.$router.push("/patrol-plan-edit?formMode=1");
      }
    },
    // 编辑
    handleUpdate (row) {
      if (this.query.category == "0") {
        GetPatrolProjectById({ id: row.id }).then((res) => {
          this.form = res.returnData;
          this.dialogVisible = true;
        });
      } else {
        this.$router.push(
          "/patrol-plan-edit?formMode=2&id=" +
          row.id +
          "&category=" +
          this.query.category
        );
      }
    },
    /**
     * 响应
     */
    planResponse (row) {
      this.$router.push("/patrol-plan-execute?id=" + row.id);
    },
    // 审批
    handleApprove (row) {
      if (this.query.category == "0") {
        this.$router.push("/patrol-plan-template?formMode=3&id=" + row.id);
      } else {
        this.$router.push("/patrol-plan-edit?formMode=3&id=" + row.id);
      }
    },
    // 删除
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将删除数据，是否继续？", "提示", {
        type: "warning",
      })
        .then(() => {
          if (this.query.category == "0") {
            return RemovePatrolProjects({ ids });
          } else {
            return RemovePatrolPlans({ ids });
          }
        })
        .then(() => {
          this.$my_message(`操作成功！`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    /**
     * 打印
     */
    handlePrint () {
      if (this.multipleSelection.length != 1) {
        this.$my_message(`只能勾选一条数据打印`, "warning");
        this.$refs.multipleTable.clearSelection();
      } else {
        let planId = "";
        switch (this.query.category) {
          case "2":
            planId = this.multipleSelection[0].id;
            this.RoutePushName("PatrolPlanPrintPreview", {
              id: planId,
              title: "巡检质控计划执行单",
            });
            break;
        }
      }
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },
    // 重置
    reset () {
      this.query.keyWord = "";
      this.$set(this.query, "pageIndex", 1);
      this.$set(this.query, "pageSize", 10);
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    handleClick (tab) {
      // this.query.type =
      let item = this.PatrolQualityControlOptions.find((e) => e.id == tab.name);
      if (item) {
        this.query.categoryName = item.name;
      }
      switch (tab.index) {
        case "0":
          this.tableColumn = this.tableColumn1;
          this.operationWidth = 140;
          break;
        case "1":
          this.tableColumn = this.tableColumn2;
          this.operationWidth = 180;
          break;
        case "2":
          this.tableColumn = this.tableColumn3;
          this.operationWidth = 140;
          break;
      }
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    toDecimal4 (row, column, cellValue, index) {
      return this.toDecimal(cellValue, 4);
    },
    // 弹框
    /**
     * 保存
     */
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SavePatrolProject(this.form).then((res) => {
          this.dialogVisible = false;
          this.$my_message(`执行成功`, "success");
          this.form = {};
          this.getData();
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    // 取消编辑部门
    cancel () {
      this.$my_confirm("确认要中断当前操作吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.form = {};
          this.dialogVisible = false;
        })
        .catch(() => { });
    },
    CanEditTem (row) {
      if (row.state == 0) {
        return this.isAdmin || this.userInfo.id == row.createdUser;
      } else {
        return false;
      }
    },
    CanEdit (row) {
      if (row.state == 1) {
        return this.isAdmin || this.userInfo.id == row.createdUser;
      } else {
        return false;
      }
    },
    CanDelete (row) {
      if (row.state == 1 || row.state == 3) {
        return this.isAdmin || this.userInfo.id == row.createdUser;
      } else {
        return false;
      }
    },
    CanResponse (row) {
      if (row.state == 2 || row.state == 1) {
        return (
          this.isAdmin ||
          this.userInfo.id == row.createdUser ||
          this.userInfo.id == row.dutyUserId
        );
      } else {
        return false;
      }
    },
  },
  mounted () { },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
    this.tableColumn = this.tableColumn1;
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.el-tabs {
  width: 420px;
  margin-bottom: 10px;
}
</style>
